<template>
  <create-account-layout
    :current-step="2"
    title="Company Type"
  >
    <p class="mb-6 mt-6 text-left text-sm text-dark-gray">
      What type of company do you work for?
    </p>
    <form
      novalidate="novalidate"
      @submit.prevent="verifySelection"
    >
      <div class="mt-6">
        <round-radio-button
          item="Carrier, Broker, or Freight Forwarder"
          name="company_type"
          :subtext="carrierSubtext"
          subtext-class="md:font-light radio-btn-subtitle"
          value="carrier"
          :checked="company_type === 'carrier'"
          :handle-click="onUpdate"
          class="mb-3"
        />
        <round-radio-button
          item="Dispatch Service"
          value="dispatch_service"
          name="company_type"
          :subtext="dispatcherSubtext"
          subtext-class="md:font-light radio-btn-subtitle"
          :checked="company_type === 'dispatch_service'"
          :handle-click="onUpdate"
          class="mb-6"
        />
        <button-main
          class="my-3 mb-4"
          type="submit"
          value="Continue"
          :disabled="!company_type"
          :loading-spinner="isLoading"
        />
      </div>
    </form>
  </create-account-layout>
  <represent-motor-carrier-modal
    :visible="areYouSureModal"
    @continue="handleContinueModal()"
    @close="handleCloseModal()"
  />
</template>

<script>
import ButtonMain from '@/components/Button.vue';
import RoundRadioButton from '@/components/RoundRadioButton.vue';
import CreateAccountLayout from '@/components/layouts/CreateAccountLayout.vue';
import RepresentMotorCarrierModal from '@/components/modals/RepresentMotorCarrierModal.vue';

export default {
  name: 'CompanyType',
  components: {
    ButtonMain,
    RoundRadioButton,
    CreateAccountLayout,
    RepresentMotorCarrierModal,
  },
  data() {
    return {
      isLoading: false,
      company_type: '',
      dispatcherSubtext:
        'I represent <b class="font-bold">multiple</b> companies',
      carrierSubtext: 'I represent <b class="font-bold">one</b> company',
      areYouSureModal: false,
    };
  },
  computed: {
    isIDVOnboardingFlowActive() {
      const status =
        this.$store.state.users.currentUser?.identity_proofing_status;
      if (status === 'skip_identity_proofing') return false;
      if (status === 'require_identity_proofing') return true;
      const featureFlagEnabled = this.$store.getters['users/getFeatureFlag']?.(
        'idv_onboarding_flow'
      )?.enabled;
      return !!featureFlagEnabled;
    },
  },
  async mounted() {
    await this.$store.dispatch('users/refreshCurrentUser');
    let currentUser = this.$store.state.users.currentUser;
    // Redirect if the user is already associated with a company
    if (currentUser?.company?.id) {
      this.$router.push({ name: 'Home' });
    }
  },
  methods: {
    handleCloseModal() {
      this.company_type = '';
      this.areYouSureModal = false;
    },
    handleContinueModal() {
      this.areYouSureModal = false;
      this.handleSubmit();
    },
    onUpdate(e) {
      this.company_type = e.target.value;
      this.$store.commit('updateSignupField', {
        name: 'company_type',
        value: e.target.value,
      });
    },
    verifySelection() {
      if (this.company_type === 'dispatch_service') {
        this.areYouSureModal = true;
      } else {
        this.handleSubmit();
      }
    },
    async handleSubmit() {
      this.isLoading = true;
      const res = await this.$store.dispatch('users/hasCarrierBeenClaimed');
      if (
        res.status === 200 ||
        ([304].includes(res.status) && res.data?.length > 0)
      ) {
        this.$store.commit('carriers/setMaskedContacts', res.data);
      }
      if (this.company_type === 'carrier') {
        if (
          res.status === 200 ||
          ([304].includes(res.status) && res.data?.length > 0)
        ) {
          this.$router.push({
            name: this.isIDVOnboardingFlowActive
              ? 'PreferredName'
              : 'GeneralInformation',
          });
        } else if (res.status === 404) {
          this.$router.push({
            name: this.isIDVOnboardingFlowActive
              ? 'PreferredName'
              : 'GeneralInformation',
          });
        }
      } else if (this.company_type === 'dispatch_service') {
        this.$store.commit('identityVerification/setRedirectAfterIDV', {
          name: '',
          path: '/sign-up/dispatcher/request-access-general-information',
        });

        this.$router.push({
          name: this.isIDVOnboardingFlowActive
            ? 'PreferredName'
            : 'DispatcherGeneralInformation',
        });
      }
      this.isLoading = false;
    },
  },
};
</script>

<style>
.button {
  @apply my-3 mb-4 bg-light-gray !important;
}

p {
  font-size: 14px;
}

.radio-btn-subtitle {
  font-size: 10px;
  line-height: 15px;
}
</style>
